var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaveBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 7.85V33C36 33.8 35.7 34.5 35.1 35.1C34.5 35.7 33.8 36 33 36H3C2.2 36 1.5 35.7 0.9 35.1C0.3 34.5 0 33.8 0 33V3C0 2.2 0.3 1.5 0.9 0.9C1.5 0.3 2.2 0 3 0H28.15L36 7.85ZM33 9.2L26.8 3H3V33H33V9.2ZM18 29.75C19.4333 29.75 20.6583 29.2417 21.675 28.225C22.6917 27.2083 23.2 25.9833 23.2 24.55C23.2 23.1167 22.6917 21.8917 21.675 20.875C20.6583 19.8583 19.4333 19.35 18 19.35C16.5667 19.35 15.3417 19.8583 14.325 20.875C13.3083 21.8917 12.8 23.1167 12.8 24.55C12.8 25.9833 13.3083 27.2083 14.325 28.225C15.3417 29.2417 16.5667 29.75 18 29.75ZM5.65 12.8H23.55V5.65H5.65V12.8ZM3 9.2V33V3V9.2Z",
    fill: "#0762A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveBtn);
export default __webpack_public_path__ + "static/media/saveBtn.cd2312bc2c1fe1e74defdfaf79121b91.svg";
export { ForwardRef as ReactComponent };